<script lang="ts">
    import {delay, copyClipboard} from "src/components/main/#common/helpers";
    import email from 'src/components/main/support/components/support-team/email.svg'
    import telegram from 'src/components/main/support/components/support-team/telegram.svg'
    import learnMore from 'src/components/main/#assets/learn-more.svg'
    import background from 'src/components/main/support/components/support-team/background.svg'

    let value = 'support@realis.network'

    let copyBtn
    let copyBtnCopied: boolean

    async function copy() {
        copyClipboard(value)
        copyBtnCopied = true
        copyBtn.style.width = copyBtn.offsetWidth + "px"
        await delay(2000)
        copyBtnCopied = false
    }
</script>
<section class="support-team" style="--Background:url({background});">
    <div class="container">
        <div class="support-card">
            <div class="icon">
                <img src="{email}" alt="">
            </div>
            <div class="info">
                <div class="title">support@realis.network</div>
                <small>Contact support team by E-mail</small>
            </div>
            <div class="action">
                <input type="hidden" id="realis-email" bind:value={value}>
                <button bind:this={copyBtn} on:click={copy} class="big-btn" disabled={copyBtnCopied}>
                    {@html copyBtnCopied ? 'Copied!' : 'Copy <span class="notranslate">E-Mail</span>' }
                </button>
            </div>
        </div>
        <div class="support-card">
            <div class="icon">
                <img src="{telegram}" alt="">
            </div>
            <div class="info">
                <div class="title">@antonova_ea</div>
                <small class="small">Head of Community</small>
            </div>
            <div class="action">
                <a href="https://t.me/antonova_ea" class="big-btn" target="_blank">Open Telegram <img src="{learnMore}" alt=""></a>
            </div>
        </div>
    </div>
</section>

<style>
    .support-team {
        margin: 150px 0 250px;
        position: relative;
    }

    .support-team:after {
        content: "";
        background: var(--Background) no-repeat center;
        position: absolute;
        left: 0;
        top: 0;
        width: 940px;
        height: 1400px;
        filter: blur(100px);
    }

    .support-card {
        width: 100%;
        border: 1px solid #FF5D1C;
        border-radius: 30px;
        display: flex;
        padding: 50px;
        background: rgba(255, 255, 255, 0.05);
        position: relative;
        z-index: 2;
        transition: .25s;
    }

    .support-card:before {
        content: "";
        width: 20px;
        height: 20px;
        background: #FF5D1C;
        box-shadow: 0 0 34px rgba(255, 165, 0, 0.5);
        border-radius: 50%;
        position: absolute;
        left: 25px;
        top: 25px;
    }

    .support-card:after {
        content: "";
        width: 20px;
        height: 20px;
        background: #979797;
        border-radius: 50%;
        position: absolute;
        left: 60px;
        top: 25px;
    }

    .support-card:first-child {
        margin-bottom: 50px;
    }

    .title {
        padding: 10px 30px;
        font-size: 30px;
        color: white;
        font-weight: 500;
        line-height: 1.3;
        margin: 0 240px 20px 0;
        min-width: 384px;
        border-radius: 10px;
        border: 1px solid #7a80c0;
        background: rgba(255, 255, 255, 0.05);
    }

    .icon {
        margin: 0 40px 0 170px;
    }

    .support-card:hover .icon {
        transform: rotateY(360deg);
        transition: 3s;
    }

    .support-card small {
        font-size: 20px;
        line-height: 20px;
        color: #CED5E3;
    }

    .action {
        position: absolute;
        right: 110px;
    }

    .big-btn {
        min-width: 193px;
        display: flex;
        justify-content: center;
    }

    @media(max-width: 1199px) {
        .icon {
            margin: 0 40px 0 60px;
        }

        .title {
            font-size: 24px;
        }

        .action {
            right: 80px;
        }

        .support-card small {
            font-size: 18px;
        }
    }

    @media(max-width: 991px) {
        .icon {
            margin: 0 40px 0 0;
        }

        .support-card {
            padding: 30px;
        }

        .title {
            padding: 12px 30px;
            font-size: 20px;
            margin: 0 40px 20px 0;
            min-width: 320px;
        }

        .action {
            right: 40px;
        }

        .support-card small {
            font-size: 16px;
        }

        .support-card:before,
        .support-card:after {
            display: none;
        }

        .support-team:after {
            display: none;
        }

        .support-card:first-child {
            margin-bottom: 30px;
        }

        .support-team {
            margin: 150px 0;
            position: relative;
        }
    }

    @media(max-width: 767px) {
        .action {
            right: auto;
            position: relative;
            margin-left: 50px;
            width: 100%;
        }

        .support-card {
            flex-wrap: wrap;
            padding: 20px;
            border-radius: 12px;
        }

        .icon {
            position: absolute;
        }

        .icon img {
            width: 40px;
            margin-right: 10px;
        }

        .info {
            margin-left: 50px;
            width: 100%;
        }

        .title {
            padding: 9px 0;
            font-size: 15px;
            margin: 0;
            min-width: 100%;
            text-align: center;
            height: 40px;
        }

        .support-card small {
            font-size: 13px;
            margin: 10px 0 18px;
            display: block;
            line-height: 20px;
        }

        .support-team .big-btn {
            margin: 0;
            width: 100%;
            display: block;
            text-align: center;
        }

        .support-team {
            margin: 50px 0 100px;
        }
    }
</style>
